export default __webpack_public_path__ + "static/media/logo_5.a874ddf8.png";